import Cookies from 'js-cookie'
import {cityMbList, mbList,} from '@/api/user'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  width:0,
  device: 'desktop',
  size: Cookies.get('size') || 'small',
  dmList: {},
  dmMap: {},
  zyList: [],
  schoolList: [],
  zyMap: {},
  schoolMap: {},
  country: [],
  city: [],
  cityTwo: [],
  cityTwoList: [],
  cityThree: [],
  cityTreeList: [],
  auditStateList: [
    {value: "0", label: '草稿'},
    {value: "1", label: '待审核'},
    {value: "2", label: '已通过'},
    {value: "3", label: '未通过'},
    {value: "4", label: '审核中'},
  ],
  auditStateMap: {
    "0": "草稿",
    "1": '待审核',
    "2": '已通过',
    "3": '未通过',
    "4": '审核中',
  }

}

const mutations = {
  setWidth:(state,width)=>{
    state.width = width
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_DM_LIST: (state, dmList) => {
    state.dmList = dmList
  },
  SET_DM_MAP: (state, dmMap) => {
    state.dmMap = dmMap
  },
  SET_SCHOOL_LIST: (state, schoolList) => {
    state.schoolList = schoolList
  },
  SET_ZY_LIST: (state, zyList) => {
    state.zyList = zyList
  },
  SET_SCHOOL_MAP: (state, schoolMap) => {
    state.schoolMap = schoolMap
  },
  SET_ZY_MAP: (state, zyMap) => {
    state.zyMap = zyMap
  },
  SET_COUNTRY: (state, country) => {
    state.country = country
  },
  SET_CITY: (state, city) => {
    state.city = city
  },
  SET_CITY_TWO: (state, cityTwo) => {
    state.cityTwo = cityTwo
  },
  SET_CITY_THREE: (state, cityThree) => {
    state.cityThree = cityThree
  },
  SET_CITY_TREE_LIST: (state, cityTreeList) => {
    state.cityTreeList = cityTreeList
  },
  SET_CITY_TWO_LIST: (state, cityTwoList) => {
    state.cityTwoList = cityTwoList
  }
}

const actions = {
  toggleSideBar({commit}) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({commit}, {withoutAnimation}) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({commit}, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({commit}, size) {
    commit('SET_SIZE', size)
  },
  // get user info
  getMb({commit, state}) {
    return new Promise((resolve, reject) => {
      // // 码表好了再删除
      // return
      // eslint-disable-next-line no-unreachable
      // xxarrlist().then(res => {
      //   commit('SET_SCHOOL_LIST', res.xxList)
      //   let schoolMap = {}
      //   res.xxList.map(item => {
      //     schoolMap[item.xxdm] = item.xxmc
      //   })
      //   commit('SET_SCHOOL_MAP', schoolMap)
      // })
      // eslint-disable-next-line no-unreachable
      // zyarrlist().then(res => {
      //   commit('SET_ZY_LIST', res.zyList)
      //   let zyMap = {}
      //   res.zyList.map(item => {
      //     zyMap[item.zydm] = item.zymc
      //   })
      //   commit('SET_ZY_MAP', zyMap)
      // })
      // eslint-disable-next-line no-unreachable
      mbList().then(data => {
        commit('SET_DM_LIST', data.data)
        let listMap = Object.assign({}, data.data)
        // eslint-disable-next-line no-unused-vars
        for (let i in listMap) {
          let obj = {}
          listMap[i].map(item => {
            obj[item.code] = item.name
          })
          listMap[i] = obj
        }
        commit('SET_DM_MAP', listMap)
        resolve(data)

        return
        // eslint-disable-next-line no-unreachable
        cityMbList().then(res => {
          data.allDmData.m_ssqdm = res.ssqdmList
          commit('SET_DM_LIST', data.allDmData)
          let listMap = Object.assign({}, data.allDmData)
          // eslint-disable-next-line no-unused-vars
          for (let i in listMap) {
            let obj = {}
            listMap[i].map(item => {
              obj[item.dm] = item.name
            })
            listMap[i] = obj
          }
          commit('SET_DM_MAP', listMap)
          let cityList = JSON.parse(JSON.stringify(data.allDmData['m_ssqdm']))
          // let country = cityList.filter(item => {
          //   if (item.level == 0) {
          //     return item.level
          //   }
          // })
          // commit('SET_COUNTRY', country)
          let city = cityList.filter(item => {
            if (item.level == 0) {
              return item.level
            }
          })
          commit('SET_CITY', city)  //城市一级list

          let cityTwo = cityList.filter(item => {
            if (item.level == 1) {
              return item.level
            }
          })
          commit('SET_CITY_TWO', cityTwo) //城市二级list

          let cityThree = cityList.filter(item => {
            if (item.level == 2) {
              return item.level
            }
          })
          commit('SET_CITY_THREE', cityThree) //城市三级list
          commit('SET_CITY_TREE_LIST', getCityTreeList())
          commit('SET_CITY_TWO_LIST', getCityTwoList())
          resolve(data)
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
}

// 城市三级
function getCityTreeList() {
  let options = [];
  if (state.city && state.city.length > 0) {
    state.city.forEach((t) => {
      let item = {
        value: t.dm,
        label: t.name,
        children: [],
      };
      if (state.cityTwo && state.cityTwo.length > 0) {
        state.cityTwo.forEach((p, i) => {
          if (t.id == p.parentid) {
            item.children.push({
              value: p.dm,
              label: p.name,
              children: [],
            });
            if (state.cityThree && state.cityThree.length > 0) {
              state.cityThree.forEach((c, index) => {
                if (p.id == c.parentid) {
                  item.children[item.children.length - 1].children.push({
                    value: c.dm,
                    label: c.name,
                  });

                }
              });
              // 删除children中没有数据的children，以便级联选择器的使用
              if (item.children[item.children.length - 1].children.length == 0) {
                delete item.children[item.children.length - 1].children
              }
            }
          }
        });
      }
      options.push(item);
    });
  }
  return options
}

// 城市两级
function getCityTwoList() {
  let options = [];
  if (state.city && state.city.length > 0) {
    state.city.forEach((t) => {
      let item = {
        value: t.dm,
        label: t.name,
        level: t.level,
        children: [],
      };
      if (state.cityTwo && state.cityTwo.length > 0) {
        state.cityTwo.forEach((p, i) => {
          if (t.id == p.parentid) {
            item.children.push({
              value: p.dm,
              label: p.name,
              level: p.level,
            });
          }
        });
      }
      options.push(item);
    });
  }
  return options
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
